<template>
  <div class="enquiry-dashboard pa-2">
    <v-row>
      <!-- Quotation by Sales Card -->
      <v-col cols="12" md="4">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white h-100">
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="d-flex align-center">
              <v-icon color="cyan darken-3" class="mr-2"
                >mdi-account-cash-outline</v-icon
              >
              <span
                class="font-weight-700 color-custom-blue font-size-16 text-uppercase"
              >
                Quotation by Sales
              </span>
              <v-chip x-small color="green" dark class="ml-2 font-weight-600"
                >Top 5</v-chip
              >
            </div>
            <div class="d-flex align-center">
              <v-select
                :menu-props="{ offsetY: true }"
                dense
                filled
                solo
                flat
                outlined
                style="width: 120px"
                :items="durationList"
                v-model="customerDuration"
                hide-details
                :disabled="issueCountLoadingNew"
                item-color="cyan"
                class="custom-menu-select mr-1"
              ></v-select>
              <v-btn
                icon
                small
                color="cyan"
                @click="resetFilterQuotationSales('sales')"
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="border rounded pa-2 grey lighten-5">
            <div
              class="d-flex align-center justify-space-between px-2 py-1 font-weight-700 font-size-12 color-custom-blue text-uppercase border-bottom mb-2"
            >
              <span class="w-50">Sales Name</span>
              <span class="w-25 text-center"
                >{{ SelectedquotationStatus }} Quote#</span
              >
              <span class="w-25 text-end">Value</span>
            </div>

            <template v-if="!countLoading">
              <template v-if="quotationPerson.length > 0">
                <div
                  v-for="(issue, index) in quotationPerson"
                  :key="index"
                  class="cursor-pointer d-flex align-center justify-space-between py-2 px-2 rounded mb-1 border"
                  :class="
                    activeIndex === index
                      ? 'cyan lighten-5 border-cyan'
                      : 'white'
                  "
                  @click="onBarClick(index, issue)"
                >
                  <div class="w-50 d-flex align-center">
                    <v-icon
                      small
                      class="mr-1"
                      :color="
                        activeIndex === index
                          ? 'cyan darken-2'
                          : 'grey darken-1'
                      "
                    >
                      {{
                        activeIndex === index
                          ? "mdi-check-circle"
                          : "mdi-chevron-right"
                      }}
                    </v-icon>
                    <span
                      class="font-size-13 font-weight-600"
                      :class="
                        activeIndex === index
                          ? 'cyan--text text--darken-3'
                          : 'color-custom-blue'
                      "
                    >
                      {{ issue.name }}
                    </span>
                  </div>
                  <div class="w-25 text-center">
                    <v-chip
                      x-small
                      dark
                      :color="issue.color"
                      class="font-weight-700"
                    >
                      {{ issue.quotationNo }}
                    </v-chip>
                  </div>
                  <div
                    class="w-25 text-end font-weight-700 font-size-13"
                    :class="
                      activeIndex === index
                        ? 'cyan--text text--darken-3'
                        : 'color-custom-blue'
                    "
                  >
                    ${{ issue.value }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center py-8 text-muted font-size-14">
                  <v-icon color="grey lighten-1" size="48" class="d-block mb-2"
                    >mdi-file-document-remove-outline</v-icon
                  >
                  No quotation available yet
                </div>
              </template>
            </template>
            <template v-else>
              <div class="d-flex align-center justify-center py-8">
                <v-progress-circular
                  indeterminate
                  color="cyan"
                  size="40"
                ></v-progress-circular>
              </div>
            </template>
          </div>
        </v-card>
      </v-col>

      <!-- Sales Person Leaderboard Card -->
      <v-col cols="12" md="4">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white h-100">
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="d-flex align-center">
              <v-icon color="cyan darken-3" class="mr-2"
                >mdi-account-star-outline</v-icon
              >
              <span
                class="font-weight-700 color-custom-blue font-size-16 text-uppercase"
              >
                Sales Leaderboard
              </span>
            </div>
            <v-select
              :menu-props="{ offsetY: true }"
              dense
              filled
              solo
              flat
              outlined
              style="max-width: 120px"
              :items="engineerdurationList"
              v-model="engcustomerDuration"
              hide-details
              :disabled="issueCountLoadingNew"
              item-color="cyan"
              class="custom-menu-select"
            ></v-select>
          </div>
          <div class="font-size-13 text-muted mb-3">
            Top sales representatives based on performance metrics.
          </div>

          <div class="enginer-profile">
            <div class="swiper-container">
              <div class="swiper">
                <div class="swiper-wrapper">
                  <template v-if="!countLoading">
                    <template
                      v-if="
                        lodash.isEmpty(slides) == false && slides.length > 0
                      "
                    >
                      <div
                        v-for="(slide, index) in slides"
                        :key="index"
                        :class="`swiper-slide swiper-slide--${slide.swipeCount}`"
                      >
                        <div class="slide-content">
                          <v-avatar size="80">
                            <v-img :src="slide.avatar" />
                          </v-avatar>
                          <h4 class="white--text mt-3">{{ slide.name }}</h4>
                        </div>
                        <div class="author">
                          <v-chip
                            :style="{
                              height: '25px',
                              border: '1px solid #fff',
                            }"
                            class="rank white-text"
                            :color="slide.rankColor"
                            text-color="white"
                          >
                            <v-icon v-if="slide.rankIcon" color="white">{{
                              slide.rankIcon
                            }}</v-icon>
                            <span class="text-h6">{{ slide.rankText }}</span>
                          </v-chip>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-center py-8 text-muted font-size-14">
                        <v-icon
                          color="grey lighten-1"
                          size="48"
                          class="d-block mb-2"
                          >mdi-account-off-outline</v-icon
                        >
                        No sales person info available yet
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <v-progress-linear
                      color="cyan"
                      indeterminate
                      rounded
                      height="4"
                      class="mt-5"
                    ></v-progress-linear>
                  </template>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Quotation Status Donut Chart -->
      <v-col cols="12" md="4">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white h-100">
          <div class="d-flex align-center justify-space-between mb-4">
            <div class="d-flex align-center">
              <v-icon color="cyan darken-3" class="mr-2"
                >mdi-file-document-outline</v-icon
              >
              <span
                class="font-weight-700 color-custom-blue font-size-16 text-uppercase"
              >
                Quotation Status
              </span>
            </div>
            <v-btn
              icon
              small
              color="cyan"
              @click="resetFilterQuotationSales('quotation')"
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </div>

          <div id="chart" class="d-flex justify-center">
            <apexchart
              type="donut"
              width="360"
              :options="quoStatuschartOptions"
              :series="quoStatusseries"
              @dataPointSelection="onBarClickQuotation"
            ></apexchart>
          </div>
        </v-card>
      </v-col>

      <!-- New & Closed / Rejected Line Chart -->
      <v-col cols="12">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white">
          <div class="d-flex align-center justify-space-between mb-4">
            <div class="d-flex align-center">
              <v-icon color="cyan darken-3" class="mr-2">mdi-chart-line</v-icon>
              <span
                class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
              >
                New & Closed / Rejected Value (6 Months)
              </span>
            </div>
            <div class="d-flex align-center">
              <v-select
                :menu-props="{ offsetY: true }"
                dense
                filled
                solo
                flat
                outlined
                style="width: 140px"
                :items="durationList"
                v-model="isDuration"
                hide-details
                :disabled="issueCountLoadingNew"
                item-color="cyan"
                class="custom-menu-select mr-1"
              ></v-select>
              <v-btn
                icon
                small
                color="cyan"
                @click="resetFilterQuotationSales('job-acpt-rej')"
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <div id="chart">
            <apexchart
              type="line"
              height="350"
              :options="newClosedJobschartOptions"
              :series="newClosedJobsseries"
            ></apexchart>
          </div>
        </v-card>
      </v-col>

      <!-- Invoices Summary Section -->
      <v-col cols="12">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white">
          <div class="d-flex align-center justify-space-between mb-3">
            <div>
              <div class="d-flex align-center">
                <v-icon color="cyan darken-3" class="mr-2"
                  >mdi-receipt-text-outline</v-icon
                >
                <span
                  class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
                >
                  Invoices Overview
                </span>
              </div>
              <div class="font-size-13 text-muted mt-1">
                Itemized breakdown of goods/services provided, costs, and
                payment status.
              </div>
            </div>
            <div class="d-flex align-center">
              <v-select
                :menu-props="{ offsetY: true }"
                dense
                filled
                solo
                flat
                outlined
                style="width: 140px"
                :items="invoicesdurationList"
                v-model="isInvoicesDuration"
                hide-details
                :disabled="issueCountLoadingNew"
                item-color="cyan"
                class="custom-menu-select mr-1"
              ></v-select>
              <v-btn
                icon
                small
                color="cyan"
                @click="resetFilterQuotationSales('invoice-counts')"
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>
          <v-row class="mt-1 flex-nowrap-md">
            <v-col
              v-for="(status, index) in invoicestatuses"
              :key="index"
              cols="12"
              sm="6"
              md=""
              class="flex-grow-1"
            >
              <v-card
                outlined
                elevation="0"
                :color="status.color"
                class="pa-3 rounded-lg white--text"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <span class="font-weight-700 font-size-15 text-uppercase">
                    {{ status.label }}
                  </span>
                  <v-chip
                    x-small
                    class="font-weight-700 color-custom-blue"
                    color="white"
                  >
                    {{ status.count }}
                  </v-chip>
                </div>
                <div class="font-size-22 font-weight-700">
                  ${{ status.value }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- New/Collected/Due Amount Line Chart -->
      <v-col cols="12">
        <v-card outlined elevation="0" class="pa-4 rounded-lg white">
          <div class="d-flex align-center justify-space-between mb-4">
            <div class="d-flex align-center">
              <v-icon color="cyan darken-3" class="mr-2"
                >mdi-cash-register</v-icon
              >
              <span
                class="font-weight-700 color-custom-blue font-size-18 text-uppercase"
              >
                New / Collected / Due Amount (6 Months)
              </span>
            </div>
            <div class="d-flex align-center">
              <v-select
                :menu-props="{ offsetY: true }"
                dense
                filled
                solo
                flat
                outlined
                style="width: 140px"
                :items="durationList"
                v-model="isInvoicesCollectedDuration"
                hide-details
                :disabled="issueCountLoadingNew"
                item-color="cyan"
                class="custom-menu-select mr-1"
              ></v-select>
              <v-btn
                icon
                small
                color="cyan"
                @click="resetFilterQuotationSales('invoice-acpt-rej')"
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <div id="chart">
            <apexchart
              type="line"
              height="350"
              :options="newInvoiceClosedJobschartOptions"
              :series="newInvoiceClosedJobsseries"
            ></apexchart>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Swiper from "swiper";
import { QUERY } from "@/core/services/store/request.module";
import { toWords } from "number-to-words";

// import "swiper/swiper-bundle.css";
export default {
  name: "ProjectStatus",
  data() {
    return {
      SelectedquotationStatus: "All",
      slides: [],
      issueCountLoadingNew: null,
      countLoading: null,
      activeIndex: null,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      draftCount: 2,
      sentCount: 2,
      partialCount: 2,
      paidCount: 2,
      cancelledCount: 2,
      value: 6000,
      max: 200,
      jobType: "service",
      invoicestatuses: [
        {
          label: "Draft",
          color: "cyan",
          textColor: "cyan--text",
          count: 0,
          value: 0,
          data_field: "draft",
        },
        {
          label: "Sent",
          color: "warning",
          textColor: "warning--text",
          count: 0,
          value: 0,
          data_field: "sent",
        },
        {
          label: "Partially Paid",
          color: "warning",
          textColor: "warning--text",
          count: 0,
          value: 0,
          data_field: "partially paid",
        },
        {
          label: "Paid",
          color: "green",
          textColor: "green--text",
          count: 0,
          value: 0,
          data_field: "paid",
        },
        {
          label: "Cancelled",
          color: "red",
          textColor: "red--text",
          count: 0,
          value: 0,
          data_field: "canceled",
        },
      ],
      quotationPerson: [
        // { name: "Lean", value: 4, quotationNo: "QT00006", color: "green" },
      ],
      selectedSalesPerson: "",
      quotationStatuses: [
        { label: "All Quotations", value: 88, textClass: "cyan--text" },
        { label: "Draft", value: 43, textClass: "cyan--text" },
        { label: "Accepted", value: 4, textClass: "success--text" },
        //{ label: "Pending For Approval", value: 12, textClass: "green--text" },
        //{ label: "Unapproval", value: 12, textClass: "green--text" },
        //{ label: "Approved", value: 12, textClass: "green--text" },
        { label: "Rejected", value: 1, textClass: "red--text" },
        { label: "Sent", value: 4, textClass: "orange--text" },
      ],
      jobTypeList: [
        { text: "Service", value: "service" },
        { text: "Installation", value: "installation" },
        { text: "Call Out", value: "call" },
        { text: "Training", value: "training" },
      ],
      quoStatusseries: [1, 1, 1, 1], // DEFAULT VALUE
      quoStatuschartOptions: {
        chart: {
          width: 450,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        colors: ["#00bcd4", "#0abb87", "#f44336", "#ff9800"],
        labels: ["Draft", "Accepted", "Rejected", "Sent"],
        dataLabels: {
          enabled: true,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        title: {
          text: "Record Count",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      customerDuration: "this_month",
      engcustomerDuration: "this_month",
      quotationStatus: "",
      engineerdurationList: [
        { text: "This Month", value: "this_month" },
        { text: "Last Month", value: "last_month" },
      ],

      jobByEngineerseries: [
        {
          name: "Draft",
          data: [44, 55, 41, 37, 22],
        },
        {
          name: "Accepted",
          data: [53, 32, 33, 52, 13],
        },
        {
          name: "Rejected",
          data: [12, 17, 11, 9, 15],
        },
        {
          name: "Sent",
          data: [9, 7, 5, 8, 6],
        },
      ],
      jobByEngineerchartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        colors: ["#008ffb", "#00e396", "#feb019", "#ff4560"],
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [
            "Michaela",
            "Rana",
            "Sally",
            "Ajai",
            "George",
            // "Terrence",
            // "Leon",
            // "Leowon",
            // "Chelsea",
          ],
          labels: {
            formatter: function (val) {
              return val + "";
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
      newClosedJobsseries: [
        {
          name: "New ",
          data: [28, 29, 33, 36, 32, 32, 33],
        },
        {
          name: "Closed ",
          data: [12, 11, 14, 18, 17, 13, 13],
        },
      ],
      newInvoiceClosedJobsseries: [
        {
          name: "New ",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Due ",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      newClosedJobschartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#F44336"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average New & Closed Jobs",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], // default values
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Jobs",
          },
          min: 1,
          max: 100,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      // ADDING NEW object for invioice newClosedJobschartOptions\
      newInvoiceClosedJobschartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#F44336"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average New & Closed Jobs",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], // default values
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Jobs",
          },
          min: 1,
          max: 100,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      // ADDING NEW object for invioice newClosedJobschartOptions
      categoryList: [
        { text: "Open", value: "open" },
        { text: "Closed", value: "closed" },
        { text: "Overdue", value: "overdue" },
      ],
      isCategory: "open",
      invoicesdurationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last 3 Month", value: "last-3month" },
        { text: "Last 6 Month", value: "last-6month" },
      ],
      isInvoicesDuration: "this_month",
      isInvoicesCollectedDuration: "this_month",
      durationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last 3 Month", value: "last-3month" },
        { text: "Last 6 Month", value: "last-6month" },
      ],
      isDuration: "this_month",
    };
  },

  methods: {
    randomValue() {
      this.value = Math.random() * this.max;
    },
    onBarClick(index, issue) {
      this.activeIndex = index;
      // const selectedPerson = this.quotationPerson[index];
      this.selectedSalesPerson = issue.prepared_by_id;
      this.getSalesContractOverview();

      this.disableOtherBars(index);
    },

    // new

    disableOtherBars(selectedIndex) {
      const defaultColors = ["#008ffb", "#00e396", "#feb019", "#ff4560"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.jobCategorychartOptions = {
        ...this.jobCategorychartOptions,
        colors: preColor,
      };
    },
    // new

    // new implementation of dynamic donut quotation

    // ending new

    onBarClickQuotation(event, chartContext, config) {
      const clickedIndex = config.dataPointIndex;
      this.activeIndex = null;

      const statusMap = {
        0: 1,
        1: 2,
        2: 3,
        3: 5,
      };

      const selectedStatus = statusMap[clickedIndex];

      this.quotationStatus = selectedStatus;

      // set the selected status
      switch (selectedStatus) {
        case 1:
          this.SelectedquotationStatus = "Draft";
          break;
        case 2:
          this.SelectedquotationStatus = "Accepted";
          break;
        case 3:
          this.SelectedquotationStatus = "Rejected";
          break;
        case 5:
          this.SelectedquotationStatus = "Sent";
          break;
        default:
          this.SelectedquotationStatus = "All";
          break;
      }
      // set the selected status

      this.getSalesContractOverview();
      this.disableOtherQuotationBars(clickedIndex);
    },

    // Modify getSalesContractOverview to accept status parameter

    disableOtherQuotationBars(selectedIndex) {
      const defaultColors = ["#00bcd4", "#0abb87", "#f44336", "#ff9800"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.quoStatuschartOptions = {
        ...this.quoStatuschartOptions,
        colors: preColor,
      };
    },

    // adding the changes for the dashboard integration api calling
    getSalesContractOverview() {
      const _this = this;
      _this.countLoading = true; // Show loading state

      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "sales_contract",
              data: {
                filter: _this.customerDuration || "this_month",
                acp_rej_filter: _this.isDuration || "last-6month",
                sales_persons: _this.selectedSalesPerson || "",
                all_sales_persons: _this.engcustomerDuration || "this_month",
                quotation_status: _this.quotationStatus || 2,
              },
            })
            .then(({ data }) => {
              _this.quotationPerson = data.salesPerson.map((person, index) => ({
                ...person,
                color: _this.getColorForIndex(index),
                value: parseFloat(person.value).toFixed(2),
              }));

              if (data.salesData && data.salesData.length > 0) {
                const statusData = data.salesData[0];
                if (statusData.quoStatusSeries.every((value) => value === 0)) {
                  _this.quoStatusseries = [1, 1, 1, 1];
                  _this.quoStatuschartOptions = {
                    ..._this.quoStatuschartOptions,
                    colors: ["#e0e0e0", "#e0e0e0", "#e0e0e0", "#e0e0e0"],
                    tooltip: {
                      enabled: true,
                      y: {
                        formatter: function () {
                          return "No data available yet!";
                        },
                      },
                    },

                    labels: [
                      "Draft (0)",
                      "Accepted (0)",
                      "Rejected (0)",
                      "Sent (0)",
                    ],
                    legend: {
                      ...(_this.quoStatuschartOptions.legend || {}),
                      formatter: function (val) {
                        return val + " - 0";
                      },
                    },
                  };
                } else {
                  _this.quoStatusseries = statusData.quoStatusSeries;
                }
              }

              _this.newClosedJobsseries = [
                {
                  name: "New ",
                  data: data.acceptGraph.accepted,
                },
                {
                  name: "Closed  ",
                  data: data.acceptGraph.rejected,
                },
              ];

              _this.newClosedJobschartOptions = {
                ..._this.newClosedJobschartOptions,
                xaxis: {
                  ..._this.newClosedJobschartOptions.xaxis,
                  categories: data.acceptGraph.months,
                },
                yaxis: {
                  max:
                    Math.max(
                      ...data.acceptGraph.accepted,
                      ...data.acceptGraph.rejected
                    ) + 10,
                  min:
                    Math.min(
                      ...data.acceptGraph.accepted,
                      ...data.acceptGraph.rejected
                    ) - 5,
                },
              };

              _this.slides = data.allSalesPersons
                // First sort the sales persons by value
                .sort((a, b) => parseFloat(b.value) - parseFloat(a.value))
                // Then map them to slides with appropriate ranks

                .map((person, index) => {
                  // Determine rank details based on position
                  const rankDetails = (() => {
                    switch (index) {
                      case 0:
                        return {
                          rankColor: "#ffd700", // Gold Rank 1
                          rankText: "Rank 1",
                          rankIcon: "mdi-crown",
                          swipeCount: "one",
                        };
                      case 1:
                        return {
                          rankColor: "#C0C0C0", // Silver
                          rankText: "Rank 2",
                          rankIcon: "",
                          swipeCount: "two",
                        };
                      case 2:
                        return {
                          rankColor: "#CD7F32", // Bronze
                          rankText: "Rank 3",
                          rankIcon: "",
                          swipeCount: "three",
                        };
                      default:
                        return {
                          rankColor: "#C0C0C0", //   for others
                          rankText: `Rank ${index + 1}`,
                          rankIcon: "",
                          swipeCount: toWords(index + 1),
                        };
                    }
                  })();

                  return {
                    avatar: _this.lodash.isEmpty(person.avatar)
                      ? "https://cdn.vuetifyjs.com/images/lists/2.jpg"
                      : person.avatar,
                    name: _this.lodash.isEmpty(person.name)
                      ? "Unknown"
                      : person.name,
                    value: parseFloat(person.value).toFixed(2),
                    quotationNo: person.quotationNo,
                    ...rankDetails,
                  };
                });
              this.initSwiper();
              // slides of sales person
              _this.countLoading = false;
              resolve(data);
            })
            .catch((error) => {
              _this.countLoading = false;
              reject(error);
            });
        } catch (error) {
          _this.countLoading = false;
          reject(error);
        }
      });
    },

    initSwiper() {
      this.swiper = new Swiper(".swiper", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 4,
          slideShadows: true,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        keyboard: {
          enabled: true,
        },
        mousewheel: {
          thresholdDelta: 70,
        },
        breakpoints: {
          560: {
            slidesPerView: 23,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 3,
          },
        },
        initialSlide: 0,
      });
    },
    getColorForIndex(index) {
      const colors = ["green", "blue", "cyan", "orange", "red"];
      return colors[index % colors.length];
    },
    validateFilter(filter) {
      const validFilters = [
        "this_week",
        "this_month",
        "last-3month",
        "last-6month",
      ];
      if (!validFilters.includes(filter)) {
        console.warn(`Invalid filter: ${filter}, using default 'this_month'`);
        return "this_month";
      }
      return filter;
    },

    resetFilterQuotationSales(type = "") {
      const commonResets = {
        sales: () => {
          this.jobByEngineerseries = "";
          this.engcustomerDuration = "this_month";
          this.quotationStatus = 2;
          this.selectedSalesPerson = "";
          this.activeIndex = null;
          this.customerDuration = "this_month";
          this.getSalesContractOverview();
        },
        quotation: () => {
          this.quoStatuschartOptions = {
            ...this.quoStatuschartOptions,
            colors: ["#00bcd4", "#0abb87", "#f44336", "#ff9800"],
          };
          this.quoStatusseries = [1, 1, 1, 1];
          this.quotationStatus = 2;
          this.engcustomerDuration = "this_month";
          this.jobByEngineerseries = "";
          this.selectedSalesPerson = "";
          this.activeIndex = null;
          this.customerDuration = "this_month";
          this.getSalesContractOverview();
        },
        "job-acpt-rej": () => {
          this.isDuration = "this_month";
          this.getSalesContractOverview();
        },
        "invoice-counts": () => {
          this.isInvoicesDuration = "this_month";
          this.getInvoiceCount();
        },
        "invoice-acpt-rej": () => {
          this.isInvoicesCollectedDuration = "this_month";
          this.getInvoiceCount();
        },
      };

      if (commonResets[type]) {
        commonResets[type]();
      }
    },
    getInvoiceCount() {
      const _this = this;
      _this.countLoading = true; // Show loading state
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "invoice_count",
              data: {
                date_range: _this.isInvoicesDuration || "this_month",
                invoice_range: this.isInvoicesCollectedDuration || "this_month",
              },
            })
            .then(({ data }) => {
              _this.invoicestatuses.forEach((stat) => {
                const matchingStatus = data.invoice_count.find(
                  (item) => item.invoice_status === stat.data_field
                );

                if (matchingStatus) {
                  stat.count = matchingStatus.invoice_count || 0;
                  stat.value = matchingStatus.total_amount || 0;
                } else {
                  stat.count = 0;
                  stat.value = "0.00";
                }
              });

              // populating line graph of invoice close,accepted
              _this.newInvoiceClosedJobsseries = [
                {
                  name: "New ",
                  data: data.acceptGraph.accepted_amount,
                },
                {
                  name: "Closed  ",
                  data: data.acceptGraph.rejected_amount,
                },
              ];

              _this.newInvoiceClosedJobschartOptions = {
                ..._this.newInvoiceClosedJobschartOptions,
                xaxis: {
                  ..._this.newInvoiceClosedJobschartOptions.xaxis,
                  categories: data.acceptGraph.months,
                },
                yaxis: {
                  max:
                    Math.max(
                      ...data.acceptGraph.accepted_amount,
                      ...data.acceptGraph.rejected_amount
                    ) + 10,
                  min:
                    Math.min(
                      ...data.acceptGraph.accepted_amount,
                      ...data.acceptGraph.rejected_amount
                    ) - 5,
                },
              };
              // populating line graph of invoice close,accepted
              _this.countLoading = false;
              resolve(data);
            })
            .catch((error) => {
              _this.countLoading = false;
              reject(error);
            });
        } catch (error) {
          _this.countLoading = false;
          reject(error);
        }
      });
    },
  },

  mounted() {
    this.getInvoiceCount();
    this.$watch(
      () => ({
        customerDuration: this.customerDuration,
        isDuration: this.isDuration,
        engcustomerDuration: this.engcustomerDuration,
      }),
      () => {
        this.getSalesContractOverview();
      },
      { deep: true }
    );
    this.$watch(
      () => ({
        isInvoicesDuration: this.isInvoicesDuration,
        isInvoicesCollectedDuration: this.isInvoicesCollectedDuration,
      }),
      () => {
        this.getInvoiceCount();
      },
      { deep: true }
    );
    this.getSalesContractOverview();
  },
  watch: {
    customerDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    isDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    engcustomerDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    isInvoicesDuration(newVal) {
      if (newVal) {
        this.getInvoiceCount();
      }
    },
    isInvoicesCollectedDuration(newVal) {
      if (newVal) {
        this.getInvoiceCount();
      }
    },
  },
};
</script>

<style scoped src="@/assets/sass/dashboard.scss" lang="scss"></style>
